import type { PageSection } from "../../pageSection";
import { PageAddressPreview } from "./PageAddressPreview";
import styles from "./PageAddressFields.module.css";

type SectionHomeAddressProps = {
  id: string;
  section: PageSection;
};

export function SectionHomeAddress({ id, section }: SectionHomeAddressProps) {
  return (
    <div className={styles.field}>
      <span className={styles.label}>Address</span>
      <p className={styles.sectionHome}>Section home</p>
      <PageAddressPreview
        id={`${id}-address`}
        section={section}
        sectionHome
        parentSlug={null}
        segment=""
      />
    </div>
  );
}
